import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { uuidValidator } from '#validation';
export const WorkspaceSsoLoginSchema = z.object({
    workspaceId: uuidValidator({
        formatError: 'internal.id.format',
    }),
    accessToken: z.string(),
});
export class WorkspaceSsoLoginDto extends createZodDto(WorkspaceSsoLoginSchema) {
}
